<script>
export default {
  name: "RubricFormActions",
  props: {
    onCancel: {
      type: Function,
      required: true,
    },
    onSubmit: {
      type: Function,
      default: null,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
    submitText: {
      type: String,
      default: null,
    },
    cancelText: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <div class="rubric-form-actions d-flex justify-content-end">
    <eg-button type="secondary" @click="onCancel">{{
      cancelText || $t("common.back")
    }}</eg-button>
    <eg-button
      v-if="onSubmit"
      :disabled="submitDisabled"
      :is-loading="submitLoading"
      class="ml-3"
      type="primary"
      data-testid="create-rubric-next-to-continue"
      @click="onSubmit"
    >
      {{ submitText || $t("common.continue") }}
    </eg-button>
  </div>
</template>

<style scoped lang="scss">
.eg-rubric-modal .rubric-form-actions {
  position: sticky;
  bottom: 0;
  padding: 1rem 1.5rem;
  background-color: white;
  border-top: 1px solid var(--color-stroke-neutral-default);
}
</style>
